import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <Section eyebrow="What physicians are looking for" title="Less searching. More structured decision-making." data-id="element-267" data-mp="3mf7r0j7onsd3">
      <ul className="grid gap-4 sm:grid-cols-2" data-id="element-268" data-mp="3r9bzx80ieagt">
        {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-3xl border border-ink-line bg-white p-5 sm:p-6" data-id="element-269" data-mp="3akyodfawpw">
            <QuoteIcon className="h-6 w-6 text-cyan-brand" aria-hidden="true" data-id="element-270" data-mp="92xmda65k2iy" />
            <p className="mt-3 flex-1 text-[15px] font-medium leading-relaxed text-ink" data-id="element-271" data-mp="e0gz25n7c78s">
              “{item.quote}”
            </p>
            <div className="mt-5 flex items-center gap-3 border-t border-ink-line pt-4" data-id="element-272" data-mp="2fsc6g92fdpl7">
              <img src={item.image} alt={item.name} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" width={96} height={96} data-id="element-273" data-mp="2fu6tbsx9brrx" />
              <div className="min-w-0" data-id="element-274" data-mp="1ivj2sm3qxs3l">
                <p className="text-[14px] font-bold text-ink" data-id="element-275" data-mp="1isdc52fgyi5r">{item.name}</p>
                <p className="text-[12.5px] font-medium text-ink-soft" data-id="element-276" data-mp="1euz5nij6aohg">
                  {item.role}
                </p>
              </div>
              <div className="ml-auto flex gap-0.5" aria-label="5 out of 5" data-id="element-277" data-mp="26kk3toa920yu">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-[#e0a11f] text-[#e0a11f]" aria-hidden="true" data-id="element-278" data-mp="22hdzwnam0lvj" data-mpi={i} />)}
              </div>
            </div>
          </li>)}
      </ul>

      <TransformCTA label="I want the same clinical clarity" sub="Join physicians using structured decision pathways instead of searching through multiple resources" data-id="element-279" data-mp="m47cyv1bghyv" />
    </Section>;
}